/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Row_Save_NoteInputs */

const vi_shop_home_row_save_note = /** @type {(inputs: Shop_Home_Row_Save_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi chỉ được lưu khi bấm Lưu khối.`)
};

/**

* @param {Shop_Home_Row_Save_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_row_save_note = /** @type {((inputs?: Shop_Home_Row_Save_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Row_Save_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_row_save_note(inputs)
});